module.exports = __webpack_public_path__ + "static/Quicksand-Regular-6cbafd2cb6e973c96ade779edc39c62a.ttf";